import React, { useState } from "react";
import { login } from "../api";

/**
 * Page de connexion — formulaire simple identifiant + mot de passe.
 */
function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      setError("Identifiant requis");
      return;
    }
    if (!password) {
      setError("Mot de passe requis");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await login(username.trim(), password);
      const data = await res.json();

      if (res.ok) {
        onLogin(data.user);
      } else {
        setError(data.error || "Erreur de connexion");
        const form = document.querySelector(".login-card");
        form?.classList.add("shake");
        setTimeout(() => form?.classList.remove("shake"), 500);
      }
    } catch (err) {
      setError("Impossible de se connecter au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">
          <span role="img" aria-label="chantier">&#x1F3D7;</span> Sobeca
        </h1>
        <p className="login-subtitle">Connectez-vous pour accéder à la liste</p>

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            className="login-input"
            placeholder="Identifiant"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
          <input
            type="password"
            className="login-input"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
}

export default LoginPage;
